import View from './View.js';
import previewView from './previewView.js';

class ProductResultView extends View {
  _parentElement = document.querySelector('.main');
  _errorMessage = 'Product Result View Error Message';
  _message = 'Product Result View Success Message';

  _generateMarkup() {
    const products = this._data
      .map(product => previewView.render(product, false))
      .reverse()
      .join('');

    return `


      <div class="row product">
        <ul class="product__search--results">
          ${products}
        </ul>
      </div>
    `;
  }
}

export default new ProductResultView();
